var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"peopleLine-control"},[_c('div',{staticClass:"peopleLine-title"},[_vm._v("人流量趋势")]),_c('div',{staticClass:"peopleLine-con"},[_c('chartsLine',{key:_vm.timer,attrs:{"option":_vm.chartsLineData,"id":"peopleLineData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }